import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	portlet: {
		padding: `${theme.spacing(6)}px 10%`
	}
}))

export default useStyles
